import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-teaching",
  "use": "icon-teaching-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-teaching\"><defs><style type=\"text/css\"></style></defs><path d=\"M734.933333 0h-85.333333v170.666667H354.773333V0h-85.333333v170.666667H0v853.333333h1024V170.666667H734.933333V0zM85.333333 938.666667V256h853.333334v682.666667z\" p-id=\"5860\" /><path d=\"M810.24 372.693333h-597.333333v85.546667h597.333333v-85.546667zM810.666667 550.4H213.333333v85.76h597.333334V550.4zM511.36 728.32h-298.666667v85.546667h298.666667v-85.546667z\" p-id=\"5861\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/teaching.svg
// module id = JCM8
// module chunks = 81